module.exports = __webpack_public_path__ + "static/media/cablebanner.0ffd967a.png";